// features/workstations/dashboard-sections/section-placeholder.js
// ═══════════════════════════════════════════════════════════
// Fallback for any section_key in the config that doesn't
// have a built component yet. Renders as a styled card
// matching the rest of the dashboard so the page always
// reads as complete — never as a broken/missing slot.
// ═══════════════════════════════════════════════════════════

import { sectionTitle } from './registry';

export default function SectionPlaceholder({ sectionKey }) {
  return (
    <section className="ws-section">
      <div className="ws-section-header">
        <div className="ws-section-label">{sectionTitle(sectionKey)}</div>
        <div className="ws-section-tag">Phase 3b · live data</div>
      </div>
      <div className="ws-section-body ws-section-empty">
        <div className="ws-section-empty-text">
          This section ships with live wiring in Phase 3b.
          The slot is reserved and will populate without a
          re-render once the data source is connected.
        </div>
      </div>
    </section>
  );
}
